import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { AdminCoupons } from "../../utils/APIClient";
import Loader from "../../common/Loader";

/**
 * Read-only audit dialog listing every redemption for a coupon.
 * Backed by GET /api/admin/coupons/<id>/redemptions/ — see
 * AdminCouponRedemptionListView (as-@action) on the backend.
 */
export default function CouponRedemptionsDialog({ coupon, onClose }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let ok = true;
        setLoading(true);
        AdminCoupons.listRedemptions(coupon.id)
            .then((resp) => {
                if (!ok) return;
                setRows(resp.data?.results || []);
                setError("");
            })
            .catch(() => {
                if (!ok) return;
                setError("Failed to load redemptions.");
            })
            .finally(() => {
                if (ok) setLoading(false);
            });
        return () => { ok = false; };
    }, [coupon.id]);

    return (
        <Modal show onHide={onClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Redemptions — <span style={{ fontFamily: "monospace" }}>{coupon.code}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center py-4"><Loader /></div>
                ) : error ? (
                    <div className="alert alert-danger">{error}</div>
                ) : rows.length === 0 ? (
                    <div className="text-muted py-3 text-center">
                        No customers have redeemed this coupon yet.
                    </div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-sm table-hover">
                            <thead>
                                <tr>
                                    <th>Redeemed at</th>
                                    <th>Organization</th>
                                    <th>Subscription</th>
                                    <th className="text-end">Original</th>
                                    <th className="text-end">Discount</th>
                                    <th>By</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((r) => (
                                    <tr key={r.id}>
                                        <td>{new Date(r.redeemed_at).toLocaleString()}</td>
                                        <td>{r.organization_name || r.organization}</td>
                                        <td>#{r.agent_subscription_id}</td>
                                        <td className="text-end">${Number(r.original_amount).toFixed(2)}</td>
                                        <td className="text-end text-success">
                                            −${Number(r.discount_amount).toFixed(2)}
                                        </td>
                                        <td>{r.redeemed_by_email || "—"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={onClose}>Close</button>
            </Modal.Footer>
        </Modal>
    );
}
